import {StatusEventType} from '@constants/machine/status-event-signal/status-event-type.enum';

export class StatusEventPageActionsParameters {
  pageId: string | null;
  visibleStatusEventTypes: StatusEventType[];
  visibleStatusEventSignals: string[];
  isInConfigurationMode: boolean;

  constructor(pageId: string | null, visibleStatusEventTypes: StatusEventType[], visibleStatusEventSignals: string[], isInConfigurationMode: boolean) {
    this.pageId = pageId;
    this.visibleStatusEventTypes = visibleStatusEventTypes;
    this.visibleStatusEventSignals = visibleStatusEventSignals;
    this.isInConfigurationMode = isInConfigurationMode;
  }
}
